export function isDropdownLink(link) {
    return link.variant !== 'link';
}
